// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const ReliableResponderSvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.yellow}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      width="20px"
      height="18px"
      viewBox="0 0 20 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g
        id="Search_Results"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Practice-Badges-Profile"
          transform="translate(-35.000000, -1374.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g
            id="ReliableResponder"
            transform="translate(25.000000, 1363.000000)"
          >
            <path
              d="M19.75,29 L27.90625,20.515625 C28.96875,19.421875 29.5,18.0859375 29.5,16.5078125 C29.5,14.9296875 28.96875,13.59375 27.90625,12.5 C26.96875,11.5 25.828125,11 24.484375,11 C23.140625,11 22,11.5 21.0625,12.5 L21.0625,12.5 L19.75,13.8125 L18.484375,12.5 C17.546875,11.5 16.3984375,11 15.0390625,11 C13.6796875,11 12.53125,11.5 11.59375,12.5 C10.53125,13.59375 10,14.9296875 10,16.5078125 C10,18.0859375 10.53125,19.421875 11.59375,20.515625 L11.59375,20.515625 L19.75,29 Z"
              id=""
            />
          </g>
        </g>
      </g>
    </svg>
  </SvgContainer>
);

ReliableResponderSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default ReliableResponderSvg;
